import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'bms-common-popup-footer',
  templateUrl: './bms-popup-common-footer-section.component.html',
  styleUrls: ['./bms-popup-common-footer-section.component.scss'],
})
export class BMSCommonPopupFooterSectionComponent implements OnChanges {
  @Input() cancelTitle: string;
  @Input() isCancelEnabled = true;
  @Input() submitTitle: string;
  @Input() isSubmitEnabled = false;
  @Input() onlyCancel = false;

  @Output() onCancelClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onSubmitClick: EventEmitter<boolean> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isSubmitEnabled) {
      this.isSubmitEnabled = changes.isSubmitEnabled.currentValue;
    }
  }

  onClickCancel() {
    this.onCancelClick.emit(true);
  }

  onClickSubmit() {
    this.onSubmitClick.emit(true);
  }
}
